"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _context = require("../context");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
var _View = _interopRequireDefault(require("./View"));
var _helperComponents = require("./app-layout/helperComponents");
var _core = require("@emotion/core");
var _excluded = ["children", "wrapper", "paddingTop", "paddingBottom", "paddingHorizontal", "isCentered", "isFullWidth", "isInAppLayout"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var ContainerBaseDefaultProps = {
  wrapper: _View.default,
  paddingTop: 0,
  paddingBottom: 0,
  paddingHorizontal: 0,
  isCentered: true,
  isFullWidth: false
};
var ContainerBase = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$wrapper = _ref.wrapper,
    Wrapper = _ref$wrapper === void 0 ? ContainerBaseDefaultProps.wrapper : _ref$wrapper,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? ContainerBaseDefaultProps.paddingTop : _ref$paddingTop,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? ContainerBaseDefaultProps.paddingBottom : _ref$paddingBottom,
    _ref$paddingHorizonta = _ref.paddingHorizontal,
    paddingHorizontal = _ref$paddingHorizonta === void 0 ? ContainerBaseDefaultProps.paddingHorizontal : _ref$paddingHorizonta,
    _ref$isCentered = _ref.isCentered,
    isCentered = _ref$isCentered === void 0 ? ContainerBaseDefaultProps.isCentered : _ref$isCentered,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? ContainerBaseDefaultProps.isFullWidth : _ref$isFullWidth,
    isInAppLayout = _ref.isInAppLayout,
    forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_context.StencilContext),
    selectors = _useContext.selectors;
  var dataProps = (0, _utils.pickDataProps)(forwardedProps);
  var viewProps = (0, _utils.omitDataProps)(forwardedProps);
  var centeredProp = isCentered ? {
    margin: [0, 'auto']
  } : {};
  var displayProp = !!viewProps.display ? {
    display: viewProps.display
  } : {};
  return (0, _core.jsx)(_helperComponents.HeaderView, (0, _extends2.default)({}, (0, _utils.omit)(viewProps, ['display']), {
    ref: ref,
    isInAppLayout: isInAppLayout,
    padding: [paddingTop, paddingHorizontal, paddingBottom]
  }), (0, _core.jsx)(Wrapper, (0, _extends2.default)({}, dataProps, centeredProp, displayProp, {
    height: "100%",
    width: "100%",
    maxWidth: isFullWidth ? '100%' : selectors.constant('maxWidth')
  }), children));
});
ContainerBase.defaultProps = ContainerBaseDefaultProps; // Force TS to accept .withComponent

var ContainerStyled = ContainerBase;
ContainerStyled.withComponent = function (tag) {
  var Wrapper = _View.default.withComponent(tag, {
    target: "e1fwr1uv0"
  });
  return /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(ContainerBase, (0, _extends2.default)({}, props, {
      ref: ref,
      wrapper: Wrapper
    }));
  });
};
var ContainerWithDocs = (0, _stencilReactDesc.describe)(ContainerStyled).description('Content wrapper with consistent padding and maximum width.');
ContainerWithDocs.propTypes = _objectSpread(_objectSpread({}, (0, _utils.omit)(_View.default.describedPropTypes, ['padding', 'margin', 'maxWidth'])), {}, {
  isFullWidth: _stencilReactDesc.PropTypes.bool.description("Determines whether to ignore theme's maxWidth and apply full width."),
  paddingTop: (0, _propTypes.cssValue)().description('Sets the top padding.'),
  paddingBottom: (0, _propTypes.cssValue)().description('Sets the bottom padding.'),
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the left and right padding.'),
  isCentered: _stencilReactDesc.PropTypes.bool.description('Horizontally centers the container.')
});
var Container = (0, _utils.withTestAttributes)({
  component: 'StencilReactContainer'
})(ContainerWithDocs);
Container.displayName = 'Container';
var _default = Container;
exports.default = _default;